import { createAction } from '@reduxjs/toolkit';
import { storeName } from '../config';

export const changeFilter = createAction<{
  key: 'reviewCycleIds' | 'userName';
  value: string | number | number[] | null;
}>(`${storeName}/changeFilter`);
